import axios from '../config/axiosPrivate';

export const getTemplateViews = async (communityId: number) => {
  const url = `/views/${communityId}/templates`;

  const response = await axios.get(url);
  return response.data;
};

export const getViews = async (communityId: number, params: any) => {
  const url = `/views/${communityId}/list`;

  const response = await axios.get(url, { params });
  return response.data;
};

export const getView = async (viewId: number, params: any) => {
  const url = `/views/${viewId}`;

  const response = await axios.get(url, { params });
  return response.data;
};

export const createView = async (payload: any) => {
  const url = `/views/`;

  const response = await axios.post(url, payload);
  return response.data;
};

export const duplicateView = async (viewId: number, payload: any) => {
  const url = `/views/${viewId}/duplicate`;

  const response = await axios.put(url, payload);
  return response.data;
};

export const duplicateBatchView = async (payload: any) => {
  const url = `/views/batch_duplicate/`;

  const response = await axios.post(url, payload);
  return response.data;
};

export const updateView = async (viewId: number, payload: any) => {
  const url = `/views/${viewId}`;

  const response = await axios.put(url, payload);
  return response.data;
};

export const updatePartialView = async (viewId: number, payload: any) => {
  const url = `/views/${viewId}`;

  const response = await axios.patch(url, payload);
  return response.data;
};

export const deleteView = async (viewId: number) => {
  const url = `/views/${viewId}`;

  const response = await axios.delete(url);
  return response.data;
};

export const linkView = async (payload: any) => {
  const url = `/views/link`;

  const response = await axios.post(url, payload);
  return response.data;
};

export const shareView = async (payload: any) => {
  const url = `/views/share`;

  const response = await axios.post(url, payload);
  return response.data;
};

export const getPublication = async (hash: string | undefined) => {
  const url = `/views/publication/${hash}`;

  const response = await axios.get(url);
  return response.data;
};
